<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "services",
    cardSetLink: "services",
    item: null,
    fields: [
      {
        col: "col-12",
        label: "Лимит времени (токен)",
        key: "is_lifetime_token",
        type: "checkbox",
      },

      {
        col: "col-12",
        label: "Активен",
        key: "is_active",
        type: "checkbox",
      },
      {
        col: "col-12 col-md-6",
        label: "Название",
        key: "name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Код",
        key: "code",
        type: "field",
      },

      {
        col: "col-12 col-md-6",
        label: "Логин",
        key: "api_login",
        type: "field",
      },

      {
        col: "col-12 col-md-6",
        label: "Пароль",
        key: "api_password",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Основная (цена/лимит)",
        labelKey: "main_price_limit",
        key: "price_fix",
        type: "field",
      },

      {
        col: "col-12 col-md-6",
        label: "Доп. цена (цена/лимит/%)",
        labelKey: "price_limit_percent",
        key: "price_percent",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "ENDPOINT URL",
        key: "api_endpoint_url",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Тип авторизации",
        key: "api_auth_type",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "TOKEN",
        key: "api_token",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "iFRAME",
        key: "iframe_url",
        type: "field",
      },

      {
        col: " col-12 col-md-12",
        key: "rate",
        label: "Допустимый рейтинг",
        labelKey: "rate_access",
        type: "static_radio",
        default: "0",
        items: [
          { id: "0", title: "0" },
          { id: "1", title: "1" },
          { id: "2", title: "2" },
          { id: "3", title: "3" },
          { id: "4", title: "4" },
          { id: "5", title: "5" },
        ],
      },
      {
        col: " col-12 col-md-12",
        key: "type_object",
        label: "Вид услуги",
        labelKey: "rate_access",
        type: "static_radio",
        default: "0",
        items: [
          { id: "0", title: "Любая" },
          { id: "1", title: "Страховая" },
          { id: "2", title: "Перепродажа" },
          { id: "3", title: "Логистика" },
        ],
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
